import { DeclaredUnit, DeclaredUnitToPlainSymbolsMap } from '../interfaces/IComponentDetails';
import { EmissionSymbol } from '../interfaces/IFootprint';

// Function to convert declared unit which directly comes from the backend, into plain text
// e.g.
//  'kilogram' => 'kilogram'
//  'cubic_meter' => 'cubic meter'
//  'ton_kilometer' => 'ton kilometer'
export const textifyDeclaredUnit = (unit?: DeclaredUnit): string => {
  return unit?.replace(/_/g, ' ') ?? '';
};

// Function to get suffix for NumberInput component in forms
// Returns string
export const getSuffixForNumberInput = (
  unit?: DeclaredUnit,
  denominatorAmount = 1,
  emissionSymbol?: EmissionSymbol,
): string => {
  if (!unit) {
    return '';
  }

  const denominatorAmountText = denominatorAmount === 1 ? '' : `${denominatorAmount} `;

  return ` ${emissionSymbol} / ${denominatorAmountText}${DeclaredUnitToPlainSymbolsMap[unit]}`;
};
